<template>
  <v-tooltip bottom>
    <template v-slot:activator="{}">
      <div class="text-center">
        <v-chip class="ma-2" :color="color" small rounded outlined>
          <v-icon v-if="!rightIcon" left small>
            {{ iconName }}
          </v-icon>
          {{ text }}
          <v-icon v-if="rightIcon" right small>
            {{ iconName }}
          </v-icon>
        </v-chip>
      </div>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
const props = {
  iconName: {
    default: "",
    type: String,
  },
  text: {
    default: "No disponible",
    type: String,
  },
  color: {
    default: "grey",
    type: String,
  },
  rightIcon: {
    default: false,
    type: Boolean,
  },
};

export default {
  data: () => ({
    valueOk: false,
  }),
  methods: {},
  props: props,
};
</script>

<style scoped></style>
